<template>
  <div>
    <v-icon
      :color="isBgWhite(card_background_color) ? '#000000' : '#FFFFFF'"
      v-if="icon !== 'twitter' && icon !== 'socialcam'"
    >
      {{ icon }}
    </v-icon>

    <TwitterSvg
      :style="iconSize"
      v-if="icon === 'twitter' && isBgWhite(card_background_color)"
    />
    <TwitterWhiteSvg
      :style="iconSize"
      v-if="icon === 'twitter' && !isBgWhite(card_background_color)"
    />

    <Globo
      :style="iconSize"
      :class="isBgWhite(card_background_color) ? 'globo-black' : 'globo'"
      v-if="icon === 'socialcam'"
    />
  </div>
</template>

<script>
import TwitterSvg from "@/assets/twitter.svg";
import TwitterWhiteSvg from "@/assets/twitter-white.svg";
import Globo from "@/assets/globo.svg";
export default {
  props: {
    fonte_colaboracao: String,
    card_background_color: String,
    icon_size: { default: "24px", type: String, required: false },
  },
  components: {
    TwitterSvg,
    Globo,
    TwitterWhiteSvg,
  },
  data() {
    return {
      icons: {
        twitter: "twitter",
        instagram: "mdi-instagram",
        whatsapp: "mdi-whatsapp",
        socialcam: "socialcam",
        youtube: "mdi-youtube",
      },
      icon: "",
    };
  },
  created() {
    this.icon = this.getIconeFonteColaboracao(this.fonte_colaboracao);
  },
  methods: {
    getIconeFonteColaboracao(fonte_colaboracao) {
      return this.icons[fonte_colaboracao.toLowerCase()];
    },
    isBgWhite(hexColor) {
      if (hexColor === undefined) {
        return false;
      }
      // fiddle this value to set stricter rules for what is white.
      var whiteLimit = 200,
        r,
        g,
        b;

      r = parseInt("0x" + hexColor.substring(1, 3));
      g = parseInt("0x" + hexColor.substring(3, 5));
      b = parseInt("0x" + hexColor.substring(5, 7));
      if (r < whiteLimit || b < whiteLimit || g < whiteLimit) {
        return false;
      }
      return true;
    },
  },
  computed: {
    iconSize() {
      return {
        width: this.icon_size,
        height: this.icon_size,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.globo {
  stop {
    stop-color: #ffffff !important;
  }

  &-black {
    stop {
      stop-color: #000000 !important;
    }
  }
}
</style>
